export const getFileLink = (filePath) => {
    return `${process.env.REACT_APP_FILE_SERVICE_URL}/${filePath}`
}